export const PUBLIC_SLUG_MIN = 8;
export const PUBLIC_SLUG_MAX = 48;

const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function normalizePublicSlug(raw: string | null | undefined): string {
  return String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
    .slice(0, PUBLIC_SLUG_MAX);
}

export function suggestPublicSlug(...parts: Array<string | null | undefined>): string {
  return normalizePublicSlug(parts.filter(Boolean).join(' '));
}

export function validatePublicSlug(raw: string | null | undefined): { ok: boolean; slug: string; message?: string } {
  const slug = normalizePublicSlug(raw);
  if (slug.length < PUBLIC_SLUG_MIN) {
    return { ok: false, slug, message: 'Use at least 8 letters or numbers. Hyphens are fine.' };
  }
  if (!SLUG_RE.test(slug)) {
    return { ok: false, slug, message: 'Use letters, numbers, and hyphens only.' };
  }
  return { ok: true, slug };
}

export function publicProfilePath(slug?: string | null, fallbackCode?: string | null): string {
  const chosen = normalizePublicSlug(slug);
  if (chosen) return `/in/${chosen}`;
  if (fallbackCode) return `/academy/${encodeURIComponent(fallbackCode)}`;
  return '';
}

export function playerPublicPath(slug?: string | null, playerIdCode?: string | null): string {
  const chosen = normalizePublicSlug(slug);
  if (chosen) return `/in/${chosen}`;
  if (playerIdCode) return `/in/${encodeURIComponent(String(playerIdCode).toLowerCase())}`;
  return '';
}
